module.exports = __webpack_public_path__ + "static/media/Image_Microsite_Announcement_1.1e3a87c8.png";